import {
  ActorPoseWire,
} from "../../../flatbuffers/mannequin";
import { Builder } from "flatbuffers";
import { ActorPoseCompressed } from "pik-solver/src/apps/mannequin/types/actor-pose";

import { vec3FromFlatBuffer, vec3ToFlatBuffer } from "../../../../util/gl-matrix/misc";

export class CompressedActorPoseSerializer {
  static serializeBinary(actorPose: ActorPoseCompressed, builder: Builder): number | undefined {
    if (
      actorPose.rootPos === undefined ||
      actorPose.packedQuats.length !== actorPose.nodeIds.length
    ) {
      console.error("invalid actor pose", actorPose);
      return undefined;
    }

    const nodeIds = ActorPoseWire.createNodeIdsVector(builder, actorPose.nodeIds);
    const quats = ActorPoseWire.createPackedQuatsVector(builder, actorPose.packedQuats);

    ActorPoseWire.startActorPoseWire(builder);
    ActorPoseWire.addUid(builder, actorPose.uid);
    ActorPoseWire.addRootPos(builder, vec3ToFlatBuffer(actorPose.rootPos, builder));
    ActorPoseWire.addPackedQuats(builder, quats);
    ActorPoseWire.addNodeIds(builder, nodeIds);
    ActorPoseWire.addGround(builder, actorPose.ground);
    ActorPoseWire.addApex(builder, actorPose.apex);
    ActorPoseWire.addScale(builder, actorPose.scale);
    return ActorPoseWire.endActorPoseWire(builder);
  }

  static deserializeBinary(actorPoseWire: ActorPoseWire): ActorPoseCompressed | undefined {
    if (actorPoseWire.nodeIdsLength() !== actorPoseWire.packedQuatsLength()) {
      console.error("unbalanced actor pose");
      return undefined;
    }

    const rootPosWire = actorPoseWire.rootPos();
    if (!rootPosWire) {
      console.error("unrooted actor pose");
      return undefined;
    }

    const packedQuats = actorPoseWire.packedQuatsArray();
    const nodeIds = actorPoseWire.nodeIdsArray();
    if (packedQuats === null || nodeIds === null) {
      console.error("blank pose data");
      return undefined;
    }

    const rootPos = vec3FromFlatBuffer(rootPosWire);

    return {
      uid: actorPoseWire.uid(),

      rootPos,

      packedQuats,
      nodeIds,

      ground: actorPoseWire.ground(),
      apex: actorPoseWire.apex(),
      scale: actorPoseWire.scale(),
    };
  }
}
